import React, { useContext, useEffect, useState } from 'react'
import NadataImage from "../commonAssests/NodataImage.svg"
import LoadingBar from './Loader/LoadingBar'
import { GlobalContext } from '../../GlobalProvider'

const NoData = ({width="100%",height="60vh",background="white",loadingProps={},isInitialLoading=false,componentLoading=null,useComponentLoading=null}) => {
  const [loading,setLoading] = useState(true)
  const {filterLoading} = useContext(GlobalContext)
  useEffect(()=>{
setTimeout(()=>{
  setLoading(false)
},[8000])
  },[])
  return (
   !filterLoading  ?(
    <>
    {
     isInitialLoading ?<>
{
  useComponentLoading?
  componentLoading ? <div className="flex items-center justify-center"
  style={
    {
      width,
      height,
      background
    }
   }
  >

  <LoadingBar width={loadingProps.width} height={loadingProps.height}  marginBotton={loadingProps.marginBotton} />
  </div>:
      <div className="flex items-center justify-center"style={
        {
          width,
          height,
          background
        }
       }>
   <img style={{
       height:"100%"
   }} src={NadataImage} alt="" />
   </div>
  
  : loading ? <div className="flex items-center justify-center"
  style={
    {
      width,
      height,
      background
    }
   }
  >

  <LoadingBar width={loadingProps.width} height={loadingProps.height}  marginBotton={loadingProps.marginBotton} />
  </div>:
      <div className="flex items-center justify-center"style={
        {
          width,
          height,
          background
        }
       }>
   <img style={{
       height:"100%"
   }} src={NadataImage} alt="" />
   </div>
  }

     </>:
           <div className="flex items-center justify-center"style={
             {
               width,
               height,
               background
             }
            }>
        <img style={{
            height:"100%"
        }} src={NadataImage} alt="" />
        </div>
    }
 </>
   ): 
<>
</>
  )
}

export default NoData
